import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { MySubmissionsComponent } from '../../catalogue/leadership/my-submissions/my-submissions.component';

@Component({
  selector: 'app-provider-my-submissions',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    MySubmissionsComponent,
  ],
  templateUrl: './my-submissions.component.html',
  styleUrl: './my-submissions.component.scss',
})
export class ProviderMySubmissionsComponent {}
